export class AboutPageComponent implements ng.IComponentOptions {
  public controller: any = AboutPageController;
  public template: string =
  `
    <div class="container container-fluid padding-2">
			<div class="row">
				<div class="col-md-12">
					<h3>Background</h3>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12" style="margin-bottom:40px">
					<p>The Institute of Labour Market Information and Analysis (ILMIA) was set up to provide excellent and professional services in the development of research and analysis on labour market issues. These services include:</p>
          <p>
            <ol type="I">
            <li>Undertaking studies and research on workforce and workplace issues.</li>
            <li>Coordinating data collection and analysis of comprehensive labour market information for dissemination to government agencies, employers, employees and the general public.</li>
            <li>Conducting workshops / seminars / forums on workforce and workplace issues in strategic partnerships with local and international agencies.</li>
            </ol>
          </p>

          <p>In order to achieve its objectives, ILMIA began an initiative in 2012 to develop the Labour Market Information Data Warehouse (LMIDW) through a smart partnership with other government agencies including the Department of Statistics, Economic Planning Unit, Labour Department and Jobs Malaysia. The purpose of the LMIDW is to centralize all labour market related data and contribute to the development of a comprehensive historical as well as forward looking indicators of the Malaysia labour market. </p>

          <p>The LMIDW is supported by a Data Flow Management System (or datamart) that helps ILMIA in managing all labour market information – from the upload of datasets by agencies, to system administration, dataset submission monitoring and integration with other modules or systems via Application Programming Interfaces (APIs).</p>

          <p>The datamart also consists of a dashboard that is capable of generating various types of reports so that users are able to view the availability of datasets by category and agency, as well as how the collected data has been utilized.</p>
				</div>
			</div>
		</div>
  `;
}

export class AboutPageController {
  public static $inject: Array<string> = ['$anchorScroll'];
  constructor (private $anchorScroll: ng.IAnchorScrollService) {

  }

  public $onInit() {
    this.$anchorScroll();
  }
}
